/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Select_Payment_EnabledInputs */

const en_admin_settings_fields_select_payment_enabled = /** @type {(inputs: Admin_Settings_Fields_Select_Payment_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show payment method selector`)
};

const zh_admin_settings_fields_select_payment_enabled = /** @type {(inputs: Admin_Settings_Fields_Select_Payment_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示支付方式选择器`)
};

/**
* | output |
* | --- |
* | "Show payment method selector" |
*
* @param {Admin_Settings_Fields_Select_Payment_EnabledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_select_payment_enabled = /** @type {((inputs?: Admin_Settings_Fields_Select_Payment_EnabledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Select_Payment_EnabledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_select_payment_enabled(inputs)
	return zh_admin_settings_fields_select_payment_enabled(inputs)
});
export { admin_settings_fields_select_payment_enabled as "admin.settings.fields.select_payment_enabled" }